import { render, staticRenderFns } from "./editDistrictAdmin.vue?vue&type=template&id=15e2e3aa&scoped=true&"
import script from "./editDistrictAdmin.vue?vue&type=script&lang=js&"
export * from "./editDistrictAdmin.vue?vue&type=script&lang=js&"
import style0 from "./editDistrictAdmin.vue?vue&type=style&index=0&id=15e2e3aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2e3aa",
  null
  
)

export default component.exports